export default "__VITE_ASSET__DaYVCZ1w__"